import React from "react";

import styles from "./ReportPageDropdown.module.scss";
import { IoClose } from "react-icons/io5";
import { useReportBespoke } from "@iliotech/data-wire";
import {
  FullScreen,
  HalfVertical,
  LeftRightHalf,
  TopBottomHalf,
  RightLeftHalf,
  BottomTopHalf,
} from "./assets";
import { TemplateType } from "@iliotech/data-wire/src/stores/ReportBespoke/ReportBespokeStore";
import { HalfHorizontal } from "./assets/HalfHorizontal";
import { FourByFour } from "./assets/FourByFour";

interface Props {
  onClose: () => void;
  pageId: string;
}
const LAYOUT_ITEMS_ROW_ONE = [
  { icon: FullScreen, id: TemplateType.FULL_SCREEN },
];
const LAYOUT_ITEMS_ROW_TWO = [
  { icon: HalfHorizontal, id: TemplateType.HALF_SCREEN_HORIZONTAL },
  { icon: HalfVertical, id: TemplateType.HALF_SCREEN_VERTICAL },
];

const LAYOUT_ITEMS_ROW_THREE = [
  { icon: RightLeftHalf, id: TemplateType.RIGHT_LEFT_SPLIT },
  { icon: LeftRightHalf, id: TemplateType.LEFT_RIGHT_SPLIT },
  { icon: TopBottomHalf, id: TemplateType.TOP_BOTTOM_SPLIT },
  { icon: BottomTopHalf, id: TemplateType.BOTTOM_TOP_SPLIT },
];
const LAYOUT_ITEMS_ROW_FOUR = [
  { icon: FourByFour, id: TemplateType.FOUR_BY_FOUR },
];

export const LayoutRows = [
  LAYOUT_ITEMS_ROW_ONE,
  LAYOUT_ITEMS_ROW_TWO,
  LAYOUT_ITEMS_ROW_THREE,
  LAYOUT_ITEMS_ROW_FOUR,
];
export const ReportLayoutDropdown: React.FC<Props> = ({ onClose, pageId }) => {
  const store = useReportBespoke();
  return (
    <div className={styles.dropdown}>
      <div className={styles.header}>
        <span>Choose layout</span>
        <IoClose className={styles.close} onClick={onClose} />
      </div>
      <div className={styles.layoutOptions}>
        {LayoutRows.map((row, index) => (
          <div key={index} className={styles.layoutOptionsRow}>
            {row.map((item) => (
              <div
                key={item.id}
                className={styles.layoutOption}
                onClick={() => store.updatePageTemplate(pageId, item.id)}
              >
                {item.icon()}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
